import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const pagesTitle: ThemeApp['appComponents']['pagesTitle'] = {
  color: themeUi.semantic.color.text.secondary950
};

export default pagesTitle;
